import { Outlet } from 'react-router-dom';
import Header from './Header';
import Navigation from './Navigation';

export default function POSLayout(): JSX.Element {
  return (
    <div className="flex flex-col h-screen bg-white">
      <Header />
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>
      <Navigation />
    </div>
  );
}
